import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import swal from "sweetalert";
import { API } from "../../../config/api";
import ModalUpdateReusable from "../../Global/ModalUpdate";
import LoaderAction from "../../Loader/LoaderAction"

export default function ModalRoleUpdate({ show, onHide, id, name, displayName, codeDisplayName, sctId, description, GetResponseData }) {
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);

    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };

    const [form, setForm] = useState({
        name: "",
        sct_id: "",
        description: "",
        display_name: "",
        code_display_name: "",
    });

    useEffect(() => {
        if (show) {
            setForm({
                name: name || "",
                display_name: displayName || "",
                code_display_name: codeDisplayName || "",
                sct_id: sctId || "",
                description: description || "",
            });
        }
    }, [show, name, displayName, codeDisplayName, sctId, description]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const mutation = useMutation(async (formData) => {
        setLoading(true);
        try {
            const response = await API.put(
                `emr-service/dental-restorations/${id}`,
                formData,
                fetchParams
            );

            if (response?.status === 200) {
                swal({
                    title: "Success",
                    text: response.data.message,
                    icon: "success",
                    timer: 3000,
                    buttons: false,
                });
                GetResponseData();
                onHide();
            }
        } catch (error) {
            swal({
                title: "Failed",
                text: error.response?.data?.message || "Something went wrong",
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        } finally {
            setLoading(false)
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        mutation.mutate(form);
    };


    return (
        <>
            {loading && <LoaderAction />}

            <ModalUpdateReusable
                isOpen={show}
                isClose={onHide}
                form={form}
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                fields={[
                    { label: "URL", name: "name", value: form.name },
                    { label: "Nama Visualisasi", name: "display_name", value: form.display_name },
                    { label: "Kode Nama Visualisasi", name: "code_display_name", value: form.code_display_name },
                    { label: "SCTID", name: "sct_id", value: form.sct_id },
                    { label: "Nama", name: "description", value: form.description }
                ]}
                title="Update Odontogram Restoration "
            />
        </>
    );
}
